import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../base";

import { useFormFieldContext } from "./context";

function FormPreviousButtonPreview({ ...props }) {
  const { field: { label } } = useFormFieldContext()

  return <BasePreview {...props}>
    <button type="button" >{label}</button>
  </BasePreview>
}

export default define('form-previous-button', FormPreviousButtonPreview, Fragment)
  .shared(prop.share('FormPreviousButton', 'form-previous-button'))
  .property(prop.predefined.customClass())
  .property(prop.predefined.content().category('standard'))
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    background: { color: 'blue-500' },
    textAlignHorizontal: 'center',
    size: {
      width: 'w-full',
    },
    textColor: 'gray-100',
    space: {
      padding: 'pt-2 pb-2 pl-3 pr-3',
    },
    border: {
      radius: {
        rounded: "sm",
      },
    },
    cursor: 'cursor-pointer',
  })
  .build()

